(function(){
  function preservePreview(){
    var current;
    try{current=new URL(window.location.href);}catch(e){return;}
    var preview=current.searchParams.get('preview_theme_id');
    if(!preview)return;
    document.querySelectorAll('a[href]').forEach(function(link){
      var raw=link.getAttribute('href');
      if(!raw||raw.charAt(0)==='#'||raw.indexOf('mailto:')===0||raw.indexOf('tel:')===0||raw.indexOf('javascript:')===0)return;
      var url;
      try{url=new URL(raw,window.location.origin);}catch(e){return;}
      if(url.origin!==window.location.origin)return;
      if(!url.searchParams.has('preview_theme_id'))url.searchParams.set('preview_theme_id',preview);
      link.setAttribute('href',url.pathname+url.search+url.hash);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',preservePreview);}else{preservePreview();}
})();
